import InlineSVG from "react-inlinesvg";
import { Switch } from "../../../sudokit/components/Switch";
import { Textarea } from "../../../sudokit/components/Textarea";

const toDomId = (value) => String(value).replace(/[^a-zA-Z0-9_-]/g, "-");

export const StoryBibleInputsSection = ({
  showStoryBible,
  onToggleStoryBible,
  storyBible,
  isStoryBibleSectionCollapsed,
  onToggleStoryBibleSection,
  onUpdateStoryBibleContent,
  getStoryBibleLabel,
}) => {
  return (
    <div className="mb-4">
      <Switch
        label="Include Story Bible Content in Test"
        labelLeft={false}
        checked={showStoryBible}
        aria-controls="plugin-tester-story-bible-content"
        onCheckedChange={onToggleStoryBible}
      />

      {showStoryBible && (
        <div id="plugin-tester-story-bible-content" className="mt-4">
          {Object.keys(storyBible).map((fieldName) => {
            const label = getStoryBibleLabel(fieldName);
            const sectionId = `plugin-tester-story-bible-${toDomId(fieldName)}-content`;
            const textareaId = `plugin-tester-story-bible-${toDomId(fieldName)}-textarea`;
            const collapsed = isStoryBibleSectionCollapsed(fieldName);

            return (
              <div
                key={fieldName}
                className="story-bible-section"
              >
                <button
                  type="button"
                  className={`story-bible-toggle ${collapsed ? "is-collapsed" : ""}`}
                  aria-expanded={!collapsed}
                  aria-controls={sectionId}
                  onClick={() => onToggleStoryBibleSection(fieldName)}
                >
                  <InlineSVG
                    src="/assets/settings_dropdown_icon.svg"
                    className="story-bible-toggle-caret"
                    aria-hidden="true"
                  />
                  <h3 className="story-bible-toggle-label">{label}</h3>
                </button>
                {!collapsed && (
                  <div id={sectionId}>
                    <Textarea
                      id={textareaId}
                      value={storyBible[fieldName]}
                      aria-label={`${label} Story Bible test content`}
                      onChange={onUpdateStoryBibleContent(fieldName)}
                      lineHeight={1.5}
                      minRows={3}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
